<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onResetSearch">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Nguồn' }}
                </div>
                <div class="">
                  <input type="text" placeholder="select" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Mã đoàn' }}
                </div>
                <div class="">
                  <input type="text" placeholder="input" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Khoảng ngày' }}
                </div>
                <div class="">
                  <CalendarRange v-model="date" mode="date" />
                </div>
              </div>
            </div>
          </div>

          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Thao tác' }}
                </div>
                <div class="">
                  <input type="text" placeholder="selectwithsearch" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Người thao tác' }}
                </div>
                <div class="">
                  <input type="text" placeholder="selectwithsearch" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Khách sạn' }}
                </div>
                <div class="">
                  <input type="text" placeholder="select" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container" style="display: flex">
            <div class="das-form-title">
              <span class="main-title">
                {{ `Báo cáo nhật ký thay đổi đoàn` }}
              </span>
            </div>

            <DownloadBtn @openNoteDialog="dialogNoteVisible = true" />
          </div>
          <hr />

          <div class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
            />
          </div>
        </div>
      </div>
    </div>

    <NoteDialog v-model="dialogNoteVisible">
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Mã đoàn: Hiển thị mã đoàn của đoàn được thao tác</li>
            <li>
              Tên trường đoàn: Hiển thị tên trưởng đoàn của đoàn được thực hiện
              thao tác
            </li>
            <li>Nguồn: Hiển thị tên nguồn của đoàn được thay đổi thông tin</li>
            <li>Ngày CI: Hiển thị ngày check-in</li>
            <li>Ngày CO: Hiển thị ngày check- out của đoàn</li>
            <li>
              Thao tác: hiển thị các thao tác được với đoàn: Tách đoàn, gộp
              đoàn, Tách bill, Gộp bill
            </li>
            <li>
              Ngày giờ thao tác: Hiển thị ngày giờ thực hiện thao tác với đoàn
            </li>
            <li>Người thao tác: Hiển thị Tên người thự hiện thao tác</li>
            <li>
              Diễn giải: hiển thị các thông tin trước và sau khi được thay đổi
            </li>
          </ul>
        </div>
      </div>
    </NoteDialog>
  </div>
</template>

<script>
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import DownloadBtn from './components/DownloadBtn.vue'
import NoteDialog from './components/NoteDialog.vue'

export default {
  components: { CalendarRange, DownloadBtn, NoteDialog },
  data() {
    return {
      // date
      date: {
        start: null,
        end: null
      },

      // grid
      columns: [
        { headerName: 'Mã đoàn', field: '' },
        { headerName: 'Tên đoàn trưởng', field: '' },
        { headerName: 'Nguồn', field: '' },
        { headerName: 'Ngày CI', field: '' },
        { headerName: 'Ngày CO', field: '' },
        { headerName: 'Thao tác', field: '' },
        { headerName: 'Ngày giờ thao tác', field: '' },
        { headerName: 'Người thao tác', field: '' },
        { headerName: 'Diễn giải', field: '' }
      ],
      rows: [],

      // dialog
      dialogNoteVisible: false
    }
  },
  methods: {
    onSearch() {},
    onResetSearch() {}
  }
}
</script>
